import { PartyPopper } from 'lucide-react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { Button } from '@/components/ui/button'

import type { AwardedTitle } from '../types'

type LocationState = {
  wonTitles: AwardedTitle[]
}

export function PaymentSuccessScreen() {
  const { rifaId } = useParams()
  const navigate = useNavigate()
  const location = useLocation()

  const state = location.state as LocationState | null
  const wonTitles = state?.wonTitles || []

  const handleNavigate = () => {
    navigate(`/campanhas/${rifaId}/participando`)
  }

  return (
    <div className="flex h-screen flex-col items-center justify-center p-4 text-center">
      <PartyPopper className="h-35 w-35 text-green-600" />
      <h1 className="mb-4 text-4xl font-bold text-green-600">
        Pagamento Aprovado!
      </h1>
      <p className="text-muted-foreground mb-8 text-lg">
        Parabéns! Sua participação na campanha foi confirmada.
      </p>

      {wonTitles.length > 0 && (
        <div className="mb-8">
          <h2 className="text-2xl font-bold text-yellow-500">
            🎉 Você ganhou!
          </h2>
          <ul className="mt-2 text-lg">
            {wonTitles.map((t) => (
              <li key={t.id}>
                Título de número: <strong>{t.titulo}</strong> - Prêmio:{' '}
                <strong>{t.premio}</strong>
              </li>
            ))}
          </ul>
        </div>
      )}

      <Button
        className="w-50 bg-green-600 text-white hover:bg-green-700"
        onClick={handleNavigate}
      >
        Ir para meus títulos
      </Button>
    </div>
  )
}
